module.exports = __webpack_public_path__ + "static/media/20180607_165557.91fb38a1.jpg";